<template>
	<div v-if="show">
		<div class="card">
			<div class="card-header card-header-flex pb-2">
				<div class="w-100 mt-2">
					<div class="row">
						<div class="col-8">
							<h5 class="mt-3 ml-0 mr-3 mb-2">
								<strong>
									<template v-if="operation === null">
                                        {{$t('title.autoGeneratedInboundLogs')}}
                                        <span v-if="pagination.total" >({{pagination.total}})</span>
                                    </template>
									<template v-else>{{ $t(operationTitle) }}</template>
								</strong>
							</h5>
						</div>
						<div class="col-4 text-right">
							<div v-if="operation === null">
								<div class="mt-3">
									<!-- Using components -->
									<b-input-group class="mt-3">
										<b-form-input type="search" class="form-control form-control-sm"
										              :placeholder="$t('input.whatAreYouLookingFor')"
										              v-on:keyup.enter="handleSearch" v-model="search"></b-form-input>
									</b-input-group>
								</div>
							</div>
							<div v-else>
								<b-button variant="warning" size="sm" class="mt-3"
								          @click="handleOperationClose()"
								          v-b-tooltip.hover :title="$t('button.title.cancel')">
									<i class="fa fa-arrow-left"></i> {{$t('button.cancel')}}
								</b-button>
							</div>
						</div>
					</div><!-- /.row -->
				</div><!-- /.w-100 -->
			</div><!-- /.card-header -->
			<div class="card-body">
                <div class="autoinboundrules-table">
                    <b-table hover responsive
                             ref="table"
                             :busy="listingLoading"
                             :items="dataSource"
                             :fields="columns"
                             :sort-by.sync="sortField"
                             @sort-changed="handleSortChange">

						<template v-slot:cell(group_id)="{ detailsShowing, item, index, rowSelected}">
							<div class="position-relative">
								<template v-if="rowSelected">
									<span aria-hidden="true">&check;</span>
								</template>
								<a @click="toggleDetails(item)" class="d-inline in-center">
									<i :class="[{'fa fa-plus': !detailsShowing}, {'fa fa-minus': detailsShowing}]"></i>
								</a>
								{{item.group_id}}
							</div>
						</template>

                        <template v-slot:cell(supplier_carrier_id)="record">
                            {{(record.item.supplier_carrier || {}).name}}
                        </template>
                        <template v-slot:cell(supplier_compound_id)="record">
                            {{(record.item.supplier_compound || {}).name}}
                        </template>
                        <template v-slot:cell(route_id)="record">
                            {{(record.item.route || {}).name}}
                        </template>
                        <template v-slot:cell(created_at)="record">
                            {{ $global.utcDateToLocalDate(record.item.created_at) }}
                        </template>
						<template v-slot:row-details="{ item }">
							<b-card>
								<b-list-group flush>
									<b-list-group-item>
										<strong v-if="!item.load_number">Error</strong>
										<strong v-else>Note</strong>:
										<pre>{{item.errors}}</pre>
									</b-list-group-item>
								</b-list-group>
							</b-card>
						</template>
                    </b-table><!-- /.b-table -->
                    <div class="clearfix">
                        <div class="float-left ">
                            <b-form-select v-model="pagination.perPage" :options="[5, 10, 50, 100, 1000]" size="sm"></b-form-select>
                        </div>
                        <div class="float-right">
                            <b-pagination
                                    v-model="pagination.current"
                                    :total-rows="pagination.total"
                                    :per-page="pagination.perPage"
                                    :first-text="$t('paginations.first')"
                                    :prev-text="$t('paginations.prev')"
                                    :next-text="$t('paginations.next')"
                                    :last-text="$t('paginations.last')"
                            ></b-pagination>
                        </div><!-- /.pull-right -->
                    </div><!-- /.clearfix -->
                </div><!-- /.autoinboundrules-table -->
                <div class="autoinboundrules-operation"></div><!--/.autoinboundrules-operation-->
				<div class="filter-container">
					<a-drawer
						placement="left"
						:width="'360px'"
						:wrapStyle="{overflow: 'auto',paddingBottom: '108px'}"
						:closable="false"
						@close="filters.visible = !filters.visible"
						:visible="!operation && filters.visible"
						:zIndex="10"
						:title="$t('title.advanceFilters')"
					>
						<form @submit.prevent="loadList(listQueryParams, true)" autocomplete="off">
							<b-row>
								<b-col sm="12">
									<b-form-group
											:label="$t('input.fromAddedDate')"
											label-for="fromDate">
										<b-form-datepicker placeholder="" id="fromDate" v-model="filters.from_date"
										                   class="mb-2"></b-form-datepicker>
									</b-form-group>
								</b-col><!--/b-col-->
								<b-col sm="12">
									<b-form-group
											:label="$t('input.toAddedDate')"
											label-for="toDate">
										<b-form-datepicker placeholder="" id="toDate" v-model="filters.to_date"
										                   class="mb-2"></b-form-datepicker>
									</b-form-group>
								</b-col><!--/b-col-->
							</b-row>
							<div class="drawer-footer">
								<b-button size='sm' variant="info" @click="filters.visible = !filters.visible"
								          class="mr-2" :title="$t('button.title.closePanel')" v-b-tooltip.hover>
									{{$t('button.close')}}
								</b-button>
								<b-button size='sm' variant="warning" @click="handleResetFilterClick" class="mr-2"
								          :title="$t('button.title.resetFilter')" v-b-tooltip.hover>
									{{$t('button.reset')}}
								</b-button>
								<b-button size='sm' variant="primary" button="submit" type="filled"
								          :title="$t('button.title.filterRecords')" v-b-tooltip.hover>
									{{$t('button.apply')}}
								</b-button>
							</div><!-- /.drawer-footer -->
						</form>
					</a-drawer>
				</div><!-- /.filter-container -->
			</div><!-- /.card-body-->
		</div><!-- /.card -->
	</div>
</template>
<script>
    import ListingMixin from '../../util/ListingMixin'
    import Error from '../../util/Error'
    import {mapState} from 'vuex'
    import Datepicker from 'vuejs-datepicker'
    import {request} from '../../util/Request'
    import Treeselect from '@riophae/vue-treeselect'

    const FORM_STATE = {};

    const FILTER_STATE = {
        visible: false,
        from_date: null,
        to_date: null,
    };

    const COLUMN_DEFINITION = (self) => [
        {
            label: self.$t('column.autoInboundRule'),
            key: 'group_id',
            sortable: true,
            sortKey: 'auto_inbound_rule_id',
        },
        {
            label: self.$t('column.loadNumber'),
            key: 'load_number',
            sortable: true,
            sortKey: 'inbound_load_id',
        },
        {
            label: self.$t('column.supplierCarrier'),
            key: 'supplier_carrier_id',
            sortable: true,
            sortKey: 'supplier_carrier_id',
        },
        {
            label: self.$t('column.supplierCompound'),
            key: 'supplier_compound_id',
            sortable: true,
            sortKey: 'supplier_compound_id',
        },
        {
            label: self.$t('column.route'),
            key: 'route_id',
            sortable: true,
            sortKey: 'route_id',
        },
        {
            label: self.$t('column.createdAt'),
            key: 'created_at',
            sortable: true,
            sortKey: 'created_at',
        },
    ];

    export default {
        mixins: [ListingMixin],
        components: {
            Datepicker,
            Treeselect
        },
        data() {
            return {
                operationTitle: 'title.autoGeneratedInboundLogs',
                formFields: {...FORM_STATE},
                filters: {...FILTER_STATE},
                listUrl: 'auto/inbound/rules/logs',
                columns: COLUMN_DEFINITION(this),
                dropdowns: {
                    types: [],
                    supplier_carriers: [],
                    supplier_compounds: [],
                },
                show: true,
            }
        },
        mounted() {
            this.$title = this.$t('topBar.navigations.modules.autoInboundLogs')
            this.getSupplierCarriers()
            this.getSupplierCompounds()

            if (this.$route.query && this.$route.query.operation && this.$route.query.oToken) {

            }
        },
        methods: {
            setOperation(operation = 'add', operationToken = null) {
                this.operationTitle = null
                this.$router.replace({
                    query: Object.assign({},
                        this.$route.query,
                        {
                            ...this.listQueryParams,
                            operation: operation,
                            oToken: operationToken,
                        },
                    ),
                }).then(() => {
                }).catch(() => {
                })
            },
			toggleDetails(row) {
				this.$set(row, '_showDetails', ((row._showDetails) ? !row._showDetails : true))
			},
            async handleSubmit() {

            },
            async getSupplierCarriers() {
                try {
                    const response = await request({
                        url: '/dropdowns/suppliers/carrier',
                        method: "post"
                    })

                    const {data} = response
                    this.dropdowns.supplier_carriers = data

                } catch (e) {
                    this.dropdowns.supplier_carriers = []
                }
            },
            async getSupplierCompounds() {
                try {
                    const response = await request({
                        url: '/dropdowns/suppliers/compound',
                        method: "post"
                    })

                    const {data} = response
                    this.dropdowns.supplier_compounds = data

                } catch (e) {
                    this.dropdowns.supplier_compounds = []
                }
            },
            hasListAccess() {
                return this.$global.hasPermission('autoinboundrulesview')
            },
            getExtraParams() {
                return {
                    filters: {
                        ...this.filters,
                        from_date: ((this.filters.from_date) ? this.$global.dateToUtcDate(this.filters.from_date, 'YYYY-MM-DD', 'YYYY-MM-DD') : ''),
                        to_date: ((this.filters.to_date) ? this.$global.dateToUtcDate(this.filters.to_date, 'YYYY-MM-DD', 'YYYY-MM-DD') : ''),
                    },
                }
            },
			handleResetFilterClick() {
				this.filters = {...FILTER_STATE}
				this.isFilterApplied = 'reset'
				this.handleResetClick()
				this.loadList(this.listQueryParams)
			},
            afterCloseOperation() {
                this.formFields = {...FORM_STATE}
            },
        },
        computed: {
            ...mapState([
                'global',
                'settings'
            ]),
        },
    }
</script>
